import { render, staticRenderFns } from "./ksDetails.vue?vue&type=template&id=298ae720&scoped=true"
import script from "./ksDetails.vue?vue&type=script&lang=js"
export * from "./ksDetails.vue?vue&type=script&lang=js"
import style0 from "./ksDetails.vue?vue&type=style&index=0&id=298ae720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ae720",
  null
  
)

export default component.exports